export default class editFnPackageCtrl {
    constructor($scope, httpRequest, $state, logger) {
        $scope.packParam = {}
        const buildTree = function (list) {
            // 适配树组件数据结构
            function recursion(data, pid) {
                const result = []
                let temp
                for (const i in data) {
                    if (data[i].parentFunctionId == pid) {
                        result.push(data[i])
                        temp = recursion(data, data[i].functionId)
                        if (temp.length > 0) {
                            data[i].children = temp
                        }
                    }
                }
                return result
            }
            return recursion(list, -1)
        }
        const getSelectedItem = function (treeData) {
            // 递归树 获取选中项返回展平数组
            const result = []
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                if (item.selected == true) {
                    result.push(item.functionId)
                }
            })
            return result
        }
        const setSelectedItem = function (treeData, selectedItems) {
            // 递归树 比较选中项目 设置 selected
            var recursionTree = function (nodes, cb) {
                for (const i in nodes) {
                    cb(nodes[i])
                    if (nodes[i].childFuncList) {
                        recursionTree(nodes[i].childFuncList, cb)
                    }
                }
            }
            recursionTree(treeData, (item) => {
                for (const i in selectedItems) {
                    if (item.functionId == selectedItems[i]) {
                        item.selected = true
                    }
                }
            })
        }
        $scope.validateRules = {
            roleName: [
                {
                    erromsg: '角色名称不得超过20个字符',
                    condition(value) {
                        return value && value.length > 20
                    },
                },
            ],
        }

        httpRequest.get_syncSysFunctionList().then((res) => {
            // 机构树
            // 如果有 选中角色  $scope.packParam.functionIdList
            $scope.fnTree = buildTree(res.data.value)
            $state.params.packId && httpRequest.get_getSysPack($state.params.packId).then((res) => {
                $scope.packParam = res.data.value
                const { functionIdList } = $scope.packParam
                setSelectedItem($scope.fnTree, functionIdList)
            })
        })
        // //发布
        $scope.submit = function submit() {
            const fnIdList = getSelectedItem($scope.fnTree)
            $scope.packParam.functionIdList = fnIdList
            if ($state.params.packId) {
                httpRequest.post_updateSysPack($scope.packParam).then(() => {
                    logger.logSuccess('功能包修改成功')
                    $state.go('system.syssetting.fnPackage.list')
                })
            } else {
                httpRequest.post_addSysPack($scope.packParam).then(() => {
                    logger.logSuccess('功能包新增成功')
                    $state.go('system.syssetting.fnPackage.list')
                })
            }
        }
        // 点击取消跳转
        $scope.cancel = function () {
            $state.go('system.syssetting.fnPackage.list')
        }
    }
}
editFnPackageCtrl.$inject = ['$scope', 'httpRequest', '$state', 'logger']



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/fnPackage/edit.js